import React from "react";

/**
 * @component RecurringDollarIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <RecurringDollarIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RecurringDollarIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="RecurringDollarIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M5.014 12a6.944 6.944 0 001.826 4.73l.21.22a7 7 0 009.727.167l.173-.167-1.414-1.414 4.871-.63-.629 4.872-1.414-1.414a9 9 0 01-12.728 0 8.892 8.892 0 01-2.498-4.789A9.016 9.016 0 013 12.01h.006V12h2.008zm7.347-8.993c2.1.084 4.175.898 5.813 2.444l.19.185.225.234.096.104.118.133a8.862 8.862 0 012.04 4.216l.043.25c.071.44.109.886.114 1.332h-.007l.001.095h-2.008a6.955 6.955 0 00-1.245-4.005l-.186-.254-.094-.12a7 7 0 00-10.238-.737l-.173.166 1.414 1.414-4.872.63.63-4.872 1.414 1.414a8.976 8.976 0 016.725-2.629z"
        clipRule="evenodd"
      />
      <path d="M13 17h-2v-1H9v-2h4v-1h-3a1 1 0 01-1-1V9a1 1 0 011-1h1V7h2v1h2v2h-4v1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1v1z" />
    </svg>
  )
);
RecurringDollarIcon.displayName = "RecurringDollarIcon";
export default RecurringDollarIcon;
